<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6DSMcu/tc-custom/9781504062411.jpg?1705405936686" alt="This image is the cover for the book Tramp Abroad"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tramp Abroad
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The classic, partly fictional travelogue through late-nineteenth-century Europe by the great American satirist and author of <i>Innocents Abroad</i>.</b></p><p>Based on true events—embellished with fictional tales and a made-up travel partner—Mark Twain’s <i>A Tramp Abroad</i> chronicles his meandering journey through Germany, the French and Swiss Alps, and Northern Italy. Attempting to make the trip by foot, Twain ventures down the Neckar river by raft, ascends Mont Blanc by telescope, and experiences European life with his usual penetrating wit, infectious curiosity, and timeless humor.</p> Along the way, Twain offers his thoughts on the role of “The Portier” in European hotels, a vivid description of “Heidelberg Castle,” and his unvarnished opinion of “The Awful German Language,” as well as a few tall tales, such as “The Man Who Put Up at Gadsby’s.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Twain
      </h2>
      
      <p class="authorDescription body article">Mark Twain was the pen name of Samuel Langhorne Clemens (1835&ndash;1910), who grew up in Hannibal, Missouri, and worked as a printer, riverboat pilot, newspaperman, and silver miner before his short story &ldquo;The Celebrated Jumping Frog of Calaveras County&rdquo; brought him international attention. He would go on to write two of the great American novels,&#160;<I>The Adventures of Tom Sawyer</I>&#160;and&#160;<I>The Adventures of Huckleberry Finn</I>, and many other enduring works of fiction, satire, and travelogue. He is one of the most widely recognized figures in US history.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Meda
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09af969e